import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { BRAND, SUPPORT_EMAIL } from "@/lib/api";
import { COMPANY, SERVICES } from "@/lib/siteContent";

export const Brand = ({ light = false }) => (
  <Link to="/" data-testid="brand-home-link" className="flex items-center gap-2.5 group">
    <span className="grid h-9 w-9 place-items-center rounded-lg bg-slate-900 text-white transition-transform duration-300 group-hover:-rotate-6">
      <ShieldCheck className="h-5 w-5" strokeWidth={2} />
    </span>
    <span className="leading-none">
      <span className={`block font-heading text-[15px] font-bold tracking-tight ${light ? "text-white" : "text-slate-900"}`}>{BRAND}</span>
      <span className={`block mt-1 text-[10px] font-semibold uppercase tracking-[0.18em] ${light ? "text-slate-300" : "text-slate-500"}`}>Servizi per condomini</span>
    </span>
  </Link>
);

const FootLinks = ({ title, links }) => (
  <div>
    <p className="text-[11px] font-semibold uppercase tracking-wider text-slate-400">{title}</p>
    <ul className="mt-3 space-y-2">
      {links.map(([to, label]) => <li key={to}><Link to={to} className="text-sm text-slate-600 hover:text-slate-900">{label}</Link></li>)}
    </ul>
  </div>
);

export const SiteFooter = () => (
  <footer className="no-print border-t border-slate-200 bg-white" data-testid="site-footer">
    <div className="mx-auto grid max-w-6xl gap-10 px-6 py-12 sm:grid-cols-2 lg:grid-cols-4">
      <div className="space-y-3">
        <Brand />
        <p className="text-sm text-slate-500" data-testid="footer-company"><span className="font-medium text-slate-700">{COMPANY.legalName}</span><br />{COMPANY.address}</p>
        <p className="text-sm text-slate-500">Tel. {COMPANY.phone} · P.IVA {COMPANY.vat}</p>
      </div>
      <FootLinks title="Servizi" links={SERVICES.map((s) => [`/servizi/${s.slug}`, s.title])} />
      <FootLinks title="Sito" links={[["/informative", "Informative condomini"], ["/normativa", "Normativa"], ["/contatti", "Contatti"]]} />
      <div>
        <p className="text-[11px] font-semibold uppercase tracking-wider text-slate-400">Assistenza</p>
        <a href={`mailto:${SUPPORT_EMAIL}`} data-testid="footer-support-email" className="mt-3 block text-sm font-medium text-blue-600 hover:underline">{SUPPORT_EMAIL}</a>
      </div>
    </div>
    <div className="border-t border-slate-100">
      <p className="mx-auto max-w-6xl px-6 py-5 text-xs text-slate-400">© {new Date().getFullYear()} {BRAND}</p>
    </div>
  </footer>
);
